/* eslint-disable no-undef */
import { Toast } from "vant";
import timer from "./timer";
import { Base64 } from 'js-base64'

/**
 * 设置storage
 * @param {*} key
 * @param {*} data
 */
export function setStorage(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

/**
 * 获取storage
 * @param {*} key
 */
export function getStorage(key) {
  if (localStorage.getItem(key) === 'undefined') {
    return null
  }
  const data = localStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
}

/**
 * 删除storage
 * @param {*} key
 */
export function removeStorage(key) {
  localStorage.removeItem(key);
}


/**
 * 是否有该参数
 * @param {*} name 
 * @returns 
 */
export function GetUrlParam(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * 判断是否是在pc端
 */
export function isPc() {
  var userAgentInfo = navigator.userAgent;
  // alert(navigator.userAgent)
  var Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod','OpenHarmony'
  ];
  var flag = true;
  for (var i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }
  return flag;
}

/**
 * ticket 微信分享凭证， detail详情
 */
export function share(ticket, detail, staticUrl) {
  wx.config({
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    ...ticket,
    jsApiList: [
      "updateAppMessageShareData",
      "updateTimelineShareData",
      "onMenuShareAppMessage"
    ], // 必填，需要使用的JS接口列表
    openTagList:[
      'wx-open-launch-app',
    ]
  });
  wx.checkJsApi({
    jsApiList: ["updateAppMessageShareData", "updateTimelineShareData", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
    success: () => {
      // 以键值对的形式返回，可用的api值true，不可用为false
      // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
      wx.ready(() => {
        let url = delQueryString(location.href, 'code')
        url = delQueryString(url, 'exclusiveId')
        url = url.replace('#reloaded', '')
        if (isIos()) {
          url = `${url}&exclusiveId=${getStorage('liveuser')?.exclusiveId}&t=${Math.random()}`
        } else {
          url = `${url}&exclusiveId=${getStorage('liveuser')?.exclusiveId}`
        }
        console.log('shareUrl', url)
        //需在用户可能点击分享按钮前就先调用
        wx.updateAppMessageShareData({
          title: detail.name, // 分享标题
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
          desc: detail.description || '点击查看详情',
          success: () => {
            // 设置成功
            console.log("ok");
          },
          fail: () => {
            //需在用户可能点击分享按钮前就先调用
            wx.onMenuShareAppMessage({
              title: detail.name, // 分享标题
              link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
              desc: detail.description || '点击查看详情',
              success: () => {
                // 设置成功
                console.log("onMenuShareAppMessage ok");
              },
              fail: (error) => {
                console.log(error)
              },
            });
          },
        });
      });

      wx.ready(() => {
        let url = location.href.replace('#reloaded', '')
        wx.updateTimelineShareData({
          title: detail.name, // 分享标题
          link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: staticUrl || 'https://dstatic.wwjrxx.com/image/logo.jpg', // 分享图标
          success: () => {
            // 设置成功
            console.log("ok");
          },
        });
      });
    },
  });
}
/**
 * 判断手机是ios
 */
export function isIos() {
  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  return isiOS
}

/**
 * 判断是否在微信环境
 */
export function isWeixin() {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1
}

/**
 * 生成uuid
 */
export function generateUUID() {
  var d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
}

/**
 * 格式化表情的收发
 */
export function formatEmoji(messageItem) {
  const replaceArr = messageItem.data.match(/[0-9]{0,}>/g);
  let otherMessage = messageItem.data.replace(/<:\//g, '<img class="emoji-icon" src="https://dstatic.wwjrxx.com/emoji/');
  if (replaceArr) {
    for (let i = 0; i < replaceArr.length; i++) {
      let index = replaceArr[i].replace('>', '');
      otherMessage = otherMessage.replace(/\/emoji\/[0-9]{0,}>/, `/emoji/${index}.png">`);
    }
  }
  messageItem.data = otherMessage
  return messageItem
}

/**
 * 发送弹幕
 */
export function showDanmu(item, that) {
  let txt = null;
  // let url = ''
  // let imgNode = '';
  // console.log('item',item)
  if (item.dataType === 6) { // 订单
    txt = `🌹${item.cloudUserName}已购买【${item.data.name}】🌹`;
  } else if (item.dataType === 8) { // 授课
    let shouke = item.data
    txt = shouke.dataType === 0 ? shouke.data : '管理员发送了图片，全屏暂不支持查看'
  } else if (item.dataType === 7) { // 回复
    txt = `@${item.aUserName}  ${item.data}`
    // const aUserLevelId = item.aUserLevelId || '';
    // if(aUserLevelId){
    //   url = `/cloud/api/oss/${Base64.encode(getVipIcon(aUserLevelId))}/preview` ;
    //   imgNode = url ? `<img src=${url} class='vip-icon replay-icon'/>`:'' 
    // } 
  }else if (item.dataType === 10) { // 回复
    txt = `收到一个表情，请退出全屏查看`
  } else {
    // txt = item.data.replace(/<img.*\/>/gi, "").replace(/<img.*>/gi, "").replace(/<\/?strong[^>]*>/gi, "");
    txt = item.data.replace(/<\/?strong[^>]*>/gi, "");
    // const cloudUserLevelId = item.cloudUserLevelId || '';
    // if(cloudUserLevelId){
    //   url = `/cloud/api/oss/${Base64.encode(getVipIcon(cloudUserLevelId))}/preview` ;
    //   imgNode = url ? `<img src=${url} class='vip-icon'/>`:'' 
    // }
  }
  let node = document.createElement('span')
  if (item.userType === 1 && item.dataType !== 6) {
    // let adminNode = document.createElement('span')
    node.innerHTML = `<span class="danmutag">${item.dataType === 8 ? '授课' : '管理员'}</span>`
    // node.appendChild(adminNode)
  }
 
  let txtNode = document.createElement('span')
  txtNode.innerHTML = isPc() ? `<span style="color:#fff;text-shadow: 0 0 2px rgb(0 0 0 / 80%), 0 1px 0 rgb(0 0 0 / 80%), 0 0 2px rgb(0 0 0 / 80%), 0 0 1px rgb(0 0 0 / 80%);font-size:20px">${item.cloudUserName}: ${txt}</span>` : `<span style="color:#fff;text-shadow: rgba(0,0,0,.2) 1px 0px 0px, rgba(0,0,0,.2) 0px 1px 0px, rgba(0,0,0,.2) -1px 0px 0px, rgba(0,0,0,.2) 0px -1px 0px;font-size:20px">${item.cloudUserName}: ${txt}</span>`
  // txtNode.innerHTML = isPc() ? `<span style="color:#fff;text-shadow: 0 0 2px rgb(0 0 0 / 80%), 0 1px 0 rgb(0 0 0 / 80%), 0 0 2px rgb(0 0 0 / 80%), 0 0 1px rgb(0 0 0 / 80%);font-size:20px"> ${imgNode}  ${item.cloudUserName}: ${txt}</span>` : `<span style="color:#fff;text-shadow: rgba(0,0,0,.2) 1px 0px 0px, rgba(0,0,0,.2) 0px 1px 0px, rgba(0,0,0,.2) -1px 0px 0px, rgba(0,0,0,.2) 0px -1px 0px;font-size:20px"> ${imgNode}${item.cloudUserName}: ${txt}</span>`
  txtNode.className = 'danmu-txt'
  node.className = 'danmu-content danmu-bg'
  node.appendChild(txtNode)

  // if (dom.length > 0) {
  that.player && that.player.danmu &&
    that.player.danmu.sendComment({
      //发送弹幕
      duration: 15000,
      id: Math.random() * 10000,
      start: 0,
      color: true,
      // txt: item.dataType === 6 ? `🌹${item.cloudUserName}：` + txt + "🌹" : `${item.cloudUserName}：` + txt,
      // style: {
      // color: "#fff",
      // fontSize: "20px",
      // border: "solid 1px #ff9500",
      // borderRadius: "50px",
      // padding: "5px 8px",
      // textShadow: "#000 3px 3px 3px",
      // },
      el: node
    });
  // }
  that.player.danmu.play();
}

/**
 * 视频全屏之后显示id水印，采用10秒发送一次弹幕
 */
export function sendIdScrollDanmu(that) {
  let idItem = {
    duration: 10000000000000000, istart: 0, mode: 'top',
    style: {
      color: '#fff',
      textShadow: '0 0 2px rgb(0 0 0 / 80%), 0 1px 0 rgb(0 0 0 / 80%), 0 0 2px rgb(0 0 0 / 80%), 0 0 1px rgb(0 0 0 / 80%)',
      fontSize: '20px',
      opacity: '0.65',
    }, txt: '无为股道'
  }
  that.player?.danmu?.sendComment({ ...idItem, id: 22 });
  that.player?.danmu?.play();
  timer.addTimer('sendIdTimer', () => {
    that.player?.danmu?.sendComment({ ...idItem, id: 22 });
    that.player?.danmu?.play();
  }, 5000)
}

export function removeSendIdScroll() {
  timer.clearTimer('sendIdTimer')
}
/**
 * div滚动到到底部
 */
export function scrollToBottom(idName, that) {
  that.$nextTick(() => {
    // setTimeout(() => {
    let container = that.$refs[`${idName}`]
    if (container) {
      container.scrollTop = container.scrollHeight + 1
    }
    // }, 500)
  });
}

/**
 * div是否滚动到顶部
 */
export function isScrollTop(idName, that) {
  let box = that.$refs[idName]
  let scrollTop = box.scrollTop;
  if (scrollTop > 0) {
    return false
  } else {
    return true
  }
}

/**
 * 判断是否滚动到了底部
 */
export function isScrollBottom(idName, that) {
  // 是否滚动到了底部
  let box = that.$refs[idName]
  var clientHeight = box.clientHeight
  var scrollTop = parseInt(box.scrollTop)
  var scrollHeight = box.scrollHeight
  if (scrollHeight > scrollTop && scrollTop + clientHeight + 1 >= scrollHeight) {
    return true
  } else {
    return false
  }
}

/**
 * 滚动方向判断
 */
var initTop = 0
export function getDirection(idName, that, dom) {
  // scroll滚动方向~~~~
  let box = dom ? dom : that.$refs[idName]
  var scrollTop = dom ? dom.getOffset() : box.scrollTop
  var scroll = scrollTop - initTop
  initTop = scrollTop
  let dir = ''
  if (scroll < 0) {
    dir = 'up'
  } else {
    dir = 'down'
  }
  return dir
}

/**
 * 特殊请求异常捕获
 */
export function catchError(error) {
  const { status } = error.response
  if (status === 401) {
    Toast.fail('登录过期')
    sessionStorage.clear()
    localStorage.clear()
   if(location.href.includes('resign')) {
    let url = delQueryString(location.href, 'code');
    location.replace(location.origin + '/login?url='+ url)
   } else {
      let url = delQueryString(location.href, 'code');
      location.replace(url)
      window.location.reload()
   }
  } else if (status === 403) {
    Toast.fail('暂无权限')
  } else if (status === 404) {
    Toast.fail('网络请求不存在')
  } else if (status === 500) {
    Toast.fail('服务器异常')
  } else if (status === 502) {
    Toast.fail('服务器未响应')
  } else {
    Toast.fail('网络开小差了～')
  }
}

/**
 * 设置cookie
 */
export function setCookie(c_name, value, expire) {
  var date = new Date()
  date.setSeconds(date.getSeconds() + expire)
  document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString()
  //console.log(document.cookie)
}
/**
 * 获取cookie
 */
export function getCookie(c_name) {
  if (document.cookie.length > 0) {
    let c_start = document.cookie.indexOf(c_name + "=")
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1
      let c_end = document.cookie.indexOf(";", c_start)
      if (c_end == -1) c_end = document.cookie.length
      return unescape(document.cookie.substring(c_start, c_end))
    }
  }
  return ""
}
/**
 * 删除cookie
 */
export function delCookie(c_name) {
  setCookie(c_name, "", -1)
}

// 删除地址栏的某个参数
export function delQueryString(url, paramKey) {
  let beforeUrl = url.substr(0, url.indexOf("?"));   //?之前主地址
  let afterUrl = url.substr(url.indexOf("?") + 1);   //？之后参数路径
  let nextUrl = "";

  let arr = new Array();
  if (afterUrl != "") {
    let urlParamArr = afterUrl.split("&"); //将参数按照&符分成数组
    for (let i = 0; i < urlParamArr.length; i++) {
      let paramArr = urlParamArr[i].split("="); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] !== paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = "?" + arr.join("&");
  }
  url = beforeUrl + nextUrl;
  return url;
}

export function checkIsLogin() {
  return getStorage('liveuser') && getCookie('t')
}
export function formatAddress(params) {
  let addr = { ...params }
  delete addr['addressDetail']
  delete addr['isDefault']
  delete addr['tel']
  delete addr['name']
  return addr
}

// 过滤出中文字符
export function filterCNStr(str) {
  const nArr = str.match(/[\u4e00-\u9fa5]/g)
  if (nArr) {
    return nArr[0]
  } else {
    return ''
  }
}

// 年月日 显示时间
export function specificDate(str){
  const date = new Date(str);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const formattedDate = year + "年" + month + "月" + day + "日";
  return formattedDate;
}

//array 转 Map
export function arrayToMap(list,propertyName){
  const map = new Map();
  if(Array.isArray(list) === false) return map;
  if(list.length === 0) return map
  list.forEach((item)=>{
    map.set(item[propertyName],item)
  })
  return map
}

//判断是否空map
export function isEmptyMap(map){
  return map.size === 0
}

export function getVipIcon(id){
  const memberLabelList = getStorage('memberLabelList');
  const cloudUserLevelMap = arrayToMap(memberLabelList,'id');
  const memberLabelConfig = cloudUserLevelMap.get(id);
  if(!memberLabelConfig) return ''
  const liveIcon = memberLabelConfig.liveIcon || {};
  const fileUrl = liveIcon && liveIcon.fileUrl || '';
  return fileUrl
 }
